/* src/app/shared/nav-tab/nav-tab.component.scss */
.nav {
  position: relative;
}
.nav ul {
  display: inline-block;
  margin: 0 0 0 0;
}
.nav li {
  display: inline-block;
  text-align: center;
  line-height: 32px;
  border-radius: 5px 5px 0 0;
  background-color: #e4e9d8;
  font-family: Segoe UI;
  font-size: 15px;
  cursor: pointer;
  margin-right: 5px;
}
.nav li.active {
  background-color: #90a65a;
}
.nav li.mofc-graph {
  width: 270px;
}
.nav li a {
  color: #90a65a;
  text-decoration: none;
  padding-left: 15px;
  padding-right: 15px;
}
.nav li.active a {
  color: white;
}
.nav .bar {
  width: 100%;
  height: 5px;
  background-color: #90a65a;
}
.nav .data-request-action {
  display: inline-block;
  color: #333;
  position: absolute;
  top: 2px;
  right: 0;
}
.nav .data-request-action span {
  font-family: arial;
  font-size: 13px;
}
.nav .data-request-action select {
  position: relative;
  width: 175px;
  height: 27px;
  padding: 0 24px 0 8px;
  margin: 0 0 0 3px;
  border-radius: 4px;
}
/*# sourceMappingURL=nav-tab.component-H2PLGDX2.css.map */
